/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import sanitizeHtml from 'sanitize-html';
import classnames from 'classnames';
import './TinyEditableContent.scss';
import TinyEditor from '../TinyEditor/TinyEditor';
import { countWords } from '../../core/helpers/word-count';
import Button from './Button';

type TinyEditableContentProps = {
  content: string;
  editMode: boolean;
  removable: boolean;
  isNew: boolean;
  wordLimit: number;
  disabled: boolean;
  formatLevel: number;
  save: (s: string) => Promise<any>;
  remove: () => Promise<any>;
};

type TinyEditableContentState = {
  content: string;
  originalContent: string;
  editMode: boolean;
};

class TinyEditableContent extends Component<TinyEditableContentProps, TinyEditableContentState> {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    content: '<p></p>',
    editMode: false,
    removable: true,
    isNew: false,
    wordLimit: null,
    disabled: false,
    formatLevel: 0,
    save: (s: string): Promise<any> => new Promise((resolve, reject) => reject(s)),
    remove: (): Promise<any> => new Promise((resolve, reject) => reject()),
  };

  constructor(props: TinyEditableContentProps) {
    super(props);

    this.state = {
      content: props.content,
      originalContent: props.content,
      editMode: props.editMode,
    };
  }

  shouldComponentUpdate(
    _nextProps: TinyEditableContentProps,
    nextState: TinyEditableContentState
  ): boolean {
    return this.state !== nextState;
  }

  toggleEditMode: any = () => {
    // if new comment is created and then press cancel without saving
    // and without modifying the default placeholder text, then remove it
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.isNew && this.state.editMode) {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.remove();
    } else {
      this.setState((state) => {
        return {
          editMode: !state.editMode,
          content: state.originalContent,
        };
      });
    }

    // if (this.state.editMode) {
    //   this.setState((state: any) => ({ boundContent: state.originalContent }));
    // }
  };

  onSave = (): void => {
    const { content } = this.state;
    if (this.exceedWordsLimit(content)) {
      alert('Text too long!');
      return;
    }
    // if there is no text, don't save
    if (content === '') {
      alert('Nothing to save! If you wish to remove the content, press "Cancel" then "Remove"!');
      return;
    }

    this.props
      .save(content)
      .then(() => {
        this.setState({
          editMode: false,
          originalContent: content,
          content,
        });
      })
      .catch(console.error);
  };

  onRemove = (): void => {
    if (window.confirm('Are you sure you wish to delete this content?')) {
      this.props
        .remove()
        .then(() => {
          if (this.props.content !== this.state.content) {
            this.setState({ content: this.props.content });
          }
        })
        .catch(console.error);
    }
  };

  handleChange = (content: string): void => {
    this.setState({ content });
  };

  exceedWordsLimit(content: string): boolean {
    const { wordLimit } = this.props;
    if (wordLimit) {
      const sanitizeConf = {
        allowedTags: [],
        allowedAttributes: {},
      };
      const sanitizedContent = sanitizeHtml(content, sanitizeConf);
      const numberOfWords = countWords(sanitizedContent);
      if (numberOfWords > this.props.wordLimit) {
        return true;
      }
    }
    return false;
  }

  render(): JSX.Element {
    const { content, editMode } = this.state;
    const { wordLimit, disabled, formatLevel } = this.props;

    const sanitizeConfText = {
      allowedTags: [],
      allowedAttributes: {},
    };
    const sanitizedContent = sanitizeHtml(content, sanitizeConfText);
    const numberOfWords = countWords(sanitizedContent);

    const wordCountOfLimit = (
      <div
        className={classnames({
          'word-limit': true,
          'word-limit-exact': numberOfWords === wordLimit,
          'word-limit-exceed': numberOfWords > wordLimit,
        })}
      >
        {numberOfWords}/{wordLimit}
      </div>
    );

    const mainButtons = (
      <div className="TinyEditableContent__buttons TinyEditableContent__buttons--hover pdf-exclude">
        <Button label="Edit" color="warning" action={this.toggleEditMode} />
        {this.props.removable ? (
          <Button label="Remove" color="danger" action={this.onRemove} />
        ) : null}
      </div>
    );

    const editModeButtons = (
      <div className="TinyEditableContent__buttons pdf-exclude">
        <Button label="Cancel" color="warning" action={this.toggleEditMode} />
        <Button label="Save" color="success" action={this.onSave} />
      </div>
    );

    const isEditableClass = !disabled && editMode ? 'TinyEditableContent--editable' : '';
    const hoverableClass = !disabled ? 'TinyEditableContent--hoverable' : '';
    const containerClass = `TinyEditableContent ${isEditableClass} ${hoverableClass}`;

    return (
      <div className={containerClass}>
        {editMode ? (
          <TinyEditor
            initialValue={content}
            disabled={!editMode}
            wordLimit={wordLimit}
            formatLevel={formatLevel}
            handleEditorChange={this.handleChange}
          />
        ) : (
          // eslint-disable-next-line react/no-danger
          <div dangerouslySetInnerHTML={{ __html: content }} />
        )}
        {!disabled ? (editMode ? editModeButtons : mainButtons) : null}
        {!disabled && wordLimit && editMode && wordCountOfLimit}
      </div>
    );
  }
}

export default TinyEditableContent;
